module.exports = __webpack_public_path__ + "img/9650CA_46236A_7239A6_633492-256px.68b034f0.png";